var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xE6\x96\x87\xE4\xBB\xB6\xE5\xA4\xB9-\xE8\x93\x9D"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M36.0784 3.51039H14.7875C10.5185 3.51039 7.05847 6.97102 7.05847 11.2394V44.7601C7.05847 49.029 10.5191 52.4891 14.7875 52.4891H41.3377C45.6066 52.4891 49.0667 49.0284 49.0667 44.7601V16.4987C49.0667 14.758 48.3754 13.0889 47.1444 11.8584L40.7186 5.43266C39.4879 4.20202 37.8188 3.51057 36.0784 3.51039V3.51039Z",
    fill: "#6CAEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M47.1444 11.8584L40.7186 5.43266C39.7967 4.51079 38.6211 3.88442 37.3417 3.63344V10.8456C37.3417 13.1354 39.1978 14.9915 41.4875 14.9915H48.8906C48.6108 13.8052 48.0062 12.7203 47.1444 11.8584Z",
    fill: "#488FE7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M30.5 23.3H37.85C38.15 23.3 38.3 23 38.3 22.7V20.9C38.3 20.6 38.15 20.3 37.85 20.3H29.15C28.7 20.3 28.55 20.9 28.85 21.2L30.2 23.15C30.2 23.3 30.35 23.3 30.5 23.3V23.3Z",
    fill: "#488FE7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M38.15 24.5H30.5C30.2 24.5 29.75 24.35 29.6 23.9L26.6 20C26.3 19.7 26 19.55 25.55 19.55H20C19.25 19.55 18.65 20.3 18.65 21.05V35.75C18.65 36.65 19.25 37.25 20 37.25H38.15C38.9 37.25 39.5 36.5 39.5 35.75V26C39.5 25.1 38.9 24.5 38.15 24.5ZM31.85 32.75C31.85 33.2 31.55 33.5 31.1 33.5H21.8C21.35 33.5 21.05 33.2 21.05 32.75C21.05 32.3 21.35 32 21.8 32H31.25C31.55 32 31.85 32.3 31.85 32.75V32.75ZM35.75 32.75C35.75 33.2 35.45 33.5 35 33.5H34.4C33.95 33.5 33.65 33.2 33.65 32.75C33.65 32.3 33.95 32 34.4 32H35C35.45 32 35.75 32.3 35.75 32.75Z",
    fill: "#488FE7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M29.5 22.3H36.85C37.15 22.3 37.3 22 37.3 21.7V19.9C37.3 19.6 37.15 19.3 36.85 19.3H28.15C27.7 19.3 27.55 19.9 27.85 20.2L29.2 22.15C29.2 22.3 29.35 22.3 29.5 22.3V22.3Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M37.15 23.5H29.5C29.2 23.5 28.75 23.35 28.6 22.9L25.6 19C25.3 18.7 25 18.55 24.55 18.55H19C18.25 18.55 17.65 19.3 17.65 20.05V34.75C17.65 35.65 18.25 36.25 19 36.25H37.15C37.9 36.25 38.5 35.5 38.5 34.75V25C38.5 24.1 37.9 23.5 37.15 23.5ZM30.85 31.75C30.85 32.2 30.55 32.5 30.1 32.5H20.8C20.35 32.5 20.05 32.2 20.05 31.75C20.05 31.3 20.35 31 20.8 31H30.25C30.55 31 30.85 31.3 30.85 31.75V31.75ZM34.75 31.75C34.75 32.2 34.45 32.5 34 32.5H33.4C32.95 32.5 32.65 32.2 32.65 31.75C32.65 31.3 32.95 31 33.4 31H34C34.45 31 34.75 31.3 34.75 31.75Z",
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg);
export default __webpack_public_path__ + "static/media/文件夹蓝.3e5f2e69bf64be9264a2ce357cf56a02.svg";
export { ForwardRef as ReactComponent };